import type { ReactNode } from 'react'

import styles from './styles.module.css'

// Каркас авторизованной зоны web: экраны kartoy сами рисуют шапки,
// здесь только тихий выход из демо-сессии.
export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.layout}>
      <main className={styles.content}>{children}</main>
    </div>
  )
}
